export const isHidden = (fieldId, formType) => {
    if (!formType || !formType.hideFields) {
        return;
    }

    return formType.hideFields.includes(fieldId);
};



// WEBPACK FOOTER //
// ./src/utils/isHidden.js